/*
 * @Author: heyouqin@moyi365.com
 * @LastEditors: heyouqin@moyi365.com
 * @Date: 2024-01-22 15:49:00
 * @LastEditTime: 2024-02-23 13:27:11
 * @Descripttion: file content
 */

import {AppModule} from '@/types/api'

const commDefaultState = {
	token: '',
	acc_type: 'tea',
	appModule: [] as AppModule[],
	audioContext: null as HTMLAudioElement | null,
	audioPaused: true,
	audioId: '' as string,
	periodId: 0 as number //period-id（1，小学，2，初中，3高中，4大学）
}

export type CommDefaultStateType = typeof commDefaultState

export default commDefaultState
